if (!customElements.get("m-product-bundle")) {
  class MProductBundle extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        bundleError: ".product-bundles__error",
        productVariantSelects: ".m-product-option--dropdown-select",
        totalPrice: "[data-total-price]",
        submitBundle: "[data-add-bundle]",
        errorWrapper: ".product-bundles__error",
        cartDrawer: "m-cart-drawer",
      };

      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.initProductBundles();
    }

    initProductBundles() {
      let allProducts = [],
        productVariants = [];
      const products = this.querySelectorAll(".product-bundles__item");

      for (let product of products) {
        let variants = product.nextElementSibling;
        if (variants && variants.hasAttribute("data-product-variants")) {
          variants = JSON.parse(variants.innerHTML);

          productVariants.push(variants);
          allProducts.push(product);

          addEventDelegate({
            context: product,
            event: "change",
            selector: this.selectors.productVariantSelects,
            handler: (e) =>
              this._handleChangePrice(e, product, variants, allProducts),
          });
        }
      }

      addEventDelegate({
        context: this,
        selector: this.selectors.submitBundle,
        handler: (e) => this._handleAddItems(e, this),
      });

      // ✅ Listen for checkbox change to update total dynamically
      this.querySelectorAll(".bundle-item-checkbox").forEach((checkbox) => {
        checkbox.addEventListener("change", () => this._updateBundleTotal());
      });

      // ✅ Initialize total once when bundle loads
      this._updateBundleTotal();
    }

    _handleChangePrice(evt, product, variants, products) {
      const regularPrice = product.querySelector("[data-regular-price]");
      let comparePrice = product.querySelector("[data-compare-price]");
      let savedPrice = product.querySelector("[data-saved-price]");
      let savedPriceWrapper = product.querySelector(
        ".product-bundles__save-price"
      );

      const selectedVariant = evt.target.value;
      const variant = variants.find((v) => v.id === parseInt(selectedVariant));

      regularPrice.innerHTML = formatMoney(
        variant.price,
        MinimogSettings.money_format
      );
      regularPrice.dataset.price = variant.price;

      this._updatePriceDisplay(
        variant,
        comparePrice,
        savedPrice,
        savedPriceWrapper
      );

      // ✅ Recalculate total if variant price changes
      this._updateBundleTotal();
    }

    _updatePriceDisplay(variant, comparePrice, savedPrice, savedPriceWrapper) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (comparePrice) {
          comparePrice.classList.remove("m:hidden");
          comparePrice.innerHTML = formatMoney(
            variant.compare_at_price,
            MinimogSettings.money_format
          );
        }
        if (savedPriceWrapper) savedPriceWrapper.classList.remove("m:hidden");
        if (savedPrice) {
          savedPrice.classList.remove("m:hidden");
          savedPrice.innerHTML = formatMoney(
            variant.compare_at_price - variant.price,
            MinimogSettings.money_format
          );
        }
      } else {
        if (comparePrice) comparePrice.classList.add("m:hidden");
        if (savedPriceWrapper) savedPriceWrapper.classList.add("m:hidden");
        if (savedPrice) savedPrice.classList.add("m:hidden");
      }
    }

    // ✅ Add only checked products to cart
    _handleAddItems(e, bundle) {
      e.preventDefault();
      const errorWrapper = bundle.querySelector(this.selectors.errorWrapper);
      const button = bundle.querySelector(this.selectors.submitBundle);
      const cartDrawer = document.querySelector(this.selectors.cartDrawer);

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      // ✅ Only include checked products
      const checkedProducts = bundle.querySelectorAll(".product-bundles__item");
      const ids = [...checkedProducts]
        .filter((product) => {
          const checkbox = product.querySelector(".bundle-item-checkbox");
          return checkbox && checkbox.checked;
        })
        .map((product) => {
          const select = product.querySelector('[name="id"]');
          return select ? select.value : null;
        })
        .filter(Boolean);

      if (ids.length === 0) {
        this._showError("Please select at least one product to add.", errorWrapper);
        return;
      }

      let data = { items: ids.map((id) => ({ id, quantity: 1 })) };
      data = {
        ...data,
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      };

      const config = fetchConfig("javascript");
      config.method = "POST";
      config.body = JSON.stringify(data);

      this._toggleLoading(true, button);

      fetch(`${MinimogSettings.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this._showError(
              response.description || "Failed to add selected items to cart!",
              errorWrapper
            );
            document.dispatchEvent(
              new CustomEvent("product-ajax:error", {
                detail: { errorMessage: response.description },
              })
            );
            return;
          }

          if (MinimogSettings.use_ajax_atc) {
            if (cartDrawer && MinimogSettings.enable_cart_drawer) {
              MinimogTheme.Notification.show({
                target: cartDrawer.querySelector("m-cart-items"),
                method: "prepend",
                type: "success",
                message: MinimogStrings.itemAdded,
                delay: 400,
              });
              cartDrawer.open();
            } else {
              window.MinimogTheme.Notification.show({
                target: errorWrapper ? errorWrapper : document.body,
                method: "appendChild",
                type: "success",
                message: MinimogStrings.itemAdded,
                last: 3000,
                sticky: !errorWrapper,
              });
            }

            window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
              cart: response,
            });

            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                detail: { product: response },
              })
            );
          } else {
            window.location = MinimogSettings.routes.cart;
          }
        })
        .catch((err) => {
          console.error("Error adding items to cart:", err);
          this._showError(
            "An error occurred while adding items to the cart.",
            errorWrapper
          );
        })
        .finally(() => {
          this._toggleLoading(false, button);
          this._updateCartDrawerState(cartDrawer);
        });
    }

    // ✅ NEW FUNCTION – updates total price on checkbox change
    _updateBundleTotal() {
      const products = this.querySelectorAll(".product-bundles__item");
      let total = 0;

      products.forEach((product) => {
        const checkbox = product.querySelector(".bundle-item-checkbox");
        if (checkbox && checkbox.checked) {
          const priceEl = product.querySelector("[data-regular-price]");
          if (priceEl && priceEl.dataset.price) {
            total += parseFloat(priceEl.dataset.price);
          }
        }
      });

      const totalDisplay = this.querySelector("[data-total-price]");
      if (totalDisplay) {
        totalDisplay.innerHTML = formatMoney(total, MinimogSettings.money_format);
      }
    }

    _updateCartDrawerState(cartDrawer) {
      if (cartDrawer) {
        const cartDrawerItems = cartDrawer.querySelector("m-cart-drawer-items");
        if (cartDrawer.classList.contains("m-cart--empty"))
          cartDrawer.classList.remove("m-cart--empty");
        if (
          cartDrawerItems &&
          cartDrawerItems.classList.contains("m-cart--empty")
        )
          cartDrawerItems.classList.remove("m-cart--empty");
      }
    }

    _showError(err, errorWrapper) {
      MinimogTheme.Notification.show({
        target: errorWrapper,
        method: "appendChild",
        type: "warning",
        message: err,
      });
    }

    _toggleLoading(loading, button) {
      if (loading) {
        button.classList.add("m-spinner-loading");
      } else {
        button.classList.remove("m-spinner-loading");
      }
    }
  }

  customElements.define("m-product-bundle", MProductBundle);
}
